import { Component, ViewEncapsulation, input } from '@angular/core';

export type LinkVariant = 'text' | 'arrow';
export type LinkColor = 'default' | 'alt';

@Component({
  selector: 'ds-link',
  templateUrl: './link.html',
  styleUrl: './link.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LinkComponent {
  readonly href = input.required<string>();
  readonly variant = input<LinkVariant>('text');
  readonly color = input<LinkColor>('default');
}
